import { render } from "./personList.vue?vue&type=template&id=0a175374&scoped=true"
import script from "./personList.vue?vue&type=script&lang=js"
export * from "./personList.vue?vue&type=script&lang=js"

import "./personList.vue?vue&type=style&index=0&id=0a175374&scoped=true&lang=css"

import exportComponent from "D:\\code\\csxlib-digital-resource\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a175374"]])

export default __exports__